// extracted by mini-css-extract-plugin
export default {"shotclassCollection":"ShotclassCollection_shotclassCollection__SroWe","loader":"ShotclassCollection_loader__HEQn+"};